// querying pages by title
export const searchPages = async (
  input,
  expandParams = [],
  expandCQL = [],
  orderBy = ""
) => {
  const expandQuery = !expandParams.length ? "" : `,${expandParams.join(",")}`;
  const expandQueryCQL = !expandCQL.length
    ? ""
    : ` and ${expandCQL.join(" and ")}`;
  const orderQuery = !orderBy ? "" : ` order by ${orderBy}`;

  const url = !input
    ? `/rest/api/content/search?expand=space${expandQuery}&cql=type=page and title ~ "*"${expandQueryCQL}${orderQuery}`
    : `/rest/api/content/search?expand=space${expandQuery}&cql=type=page and title ~ "${input}*"${expandQueryCQL}${orderQuery}`;

  try {
    const response = await window.AP.request(url);
    const body = JSON.parse(response.body);
    return body;
  } catch (err) {
    console.log(err);
    return [];
  }
};

export const getPageById = async (pageId) => {
  try {
    const response = await window.AP.request(
      `/rest/api/content/search?expand=space&cql=type=page and id=${pageId}`
    );
    const body = JSON.parse(response.body);
    const page = body.results[0];
    return page;
  } catch (err) {
    console.log(err);
    return {};
  }
};

export const getPagesByIds = async (pageIds) => {
  try {
    const pages = await Promise.all(
      pageIds.map(async (id) => {
        const page = await getPageById(id);
        return page;
      })
    );
    return pages;
  } catch (err) {
    console.log(err);
    return [];
  }
};

// returning limit (25 default) of pages
export const getPagesBySpaceKey = async (spaceKey) => {
  try {
    const response = await window.AP.request(
      `/rest/api/content/?spaceKey=${spaceKey}&expand=space`
    );
    const body = JSON.parse(response.body);
    console.log(body);
    const pages = body.results;
    return pages;
  } catch (err) {
    console.log(err);
    return [];
  }
};

export const getPagesByMultipleSpaces = async (spaceKeys) => {
  try {
    const pages = await Promise.all(
      spaceKeys.map(async (key) => {
        const pagesBySpace = await getPagesBySpaceKey(key);
        return pagesBySpace;
      })
    );
    return pages.reduce((acc, val) => [...acc, ...val], []);
  } catch (err) {
    console.log(err);
    return [];
  }
};

export const extractPageDataForSelect = (pages) => {
  const keyNamePairs = pages.map((page) => ({
    label: page.title,
    value: page.id,
  }));
  return keyNamePairs;
};
